import { z } from 'zod';
import { ProtocolWithCoordinatesSchema } from '@/api/schema/protocol';
import { UserSnapshotSchema } from './user';

export const EligibilityStatusSchema = z.object({
  id: z.string(),
  protocol: ProtocolWithCoordinatesSchema,
  isEligibleOverall: z.boolean(),
  overallEligibilityCheckedBy: UserSnapshotSchema.nullable(),
  overallEligibilityCheckedAt: z.string().nullable(),
  overallEligibilityStatus: z.string(),
  criterionChecks: z.array(z.unknown()),
});

export const PhaseSchema = z.object({
  id: z.string(),
  name: z.string(),
  icon: z.string(),
  order: z.number(),
  protocol: ProtocolWithCoordinatesSchema,
});

export type EligibilityStatus = z.infer<typeof EligibilityStatusSchema>;
export type Phase = z.infer<typeof PhaseSchema>;
